<template>
	<div class="landing-page">
		<!-- Hero Section -->
		<section class="hero-section d-flex align-items-center">
			<div class="container">
				<div class="row">
					<!-- Left Column: Headline and CTA -->
					<div
						class="col-md-6 d-flex flex-column justify-content-center text-md-start text-center">
						<h1 class="display-3 fw-bold mb-3">
							Discover Food<br />with Your Camera<br />for FREE!
						</h1>
						<p class="lead mb-4">
							Simply snap a photo of your meal and get nutritional information,
							personalized recommendations, and health insights.
						</p>
						<div
							class="d-flex gap-3 flex-wrap justify-content-center"
							v-if="!Capacitor.isNativePlatform()">
							<router-link to="/signin" class="btn btn-dark btn-lg"
								>Use Web Version</router-link
							>
							<a
								href="https://play.google.com/store/apps/details?id=com.digitalfuturelabs.grubvision"
								target="_blank"
								class="btn btn-dark btn-lg d-flex align-items-center gap-2">
								<i class="bi bi-google-play"></i>
								<span>Google Play</span>
							</a>
						</div>
						<div class="d-flex gap-3 flex-wrap justify-content-center" v-else>
							<router-link to="/signin" class="btn btn-dark btn-lg"
								>Login</router-link
							>
							<router-link to="/signup" class="btn btn-success btn-lg"
								>Sign up</router-link
							>
						</div>
					</div>
					<!-- Right Column: Phone Image -->
					<div class="col-md-6 text-center">
						<img
							src="../assets/phone.png"
							alt="Grub Vision App Screenshot"
							class="img-fluid hero-img" />
					</div>
				</div>
			</div>
		</section>

		<!-- Features Section -->
		<section id="features" class="features-section py-5">
			<div class="container">
				<h2 class="text-center fw-bold mb-5">App Features</h2>
				<div class="row text-center">
					<div class="col-md-4 mb-4">
						<img
							src="../assets/icon-dish.png"
							alt="Identify Dishes"
							class="mb-3" />
						<h5 class="fw-bold">Identify Dishes</h5>
						<p>
							Snap a photo to instantly identify various dishes using advanced
							image recognition technology.
						</p>
					</div>
					<div class="col-md-4 mb-4">
						<img
							src="../assets/icon-nutrition.png"
							alt="Get Nutritional Info"
							class="mb-3" />
						<h5 class="fw-bold">Get Nutritional Info</h5>
						<p>
							Gain insights into the nutritional content of your meals,
							including calories, and more.
						</p>
					</div>
					<div class="col-md-4 mb-4">
						<img
							src="../assets/icon-recipe.png"
							alt="Explore Recipes"
							class="mb-3" />
						<h5 class="fw-bold">Health Reports</h5>
						<p>
							View personalized insights and track your nutritional trends over
							time.
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Marketing Copy Section (NEW) -->
		<section class="marketing-copy-section py-5">
			<div class="welcome-bg-gradient py-4 px-2">
				<div class="container">
					<div class="row justify-content-center mb-4">
						<div class="col-lg-10 mx-auto text-center">
							<div
								class="welcome-card p-5 rounded-5 shadow-lg position-relative">
								<h2 class="welcome-title mb-2">Welcome to Grub Vision!</h2>
								<div class="welcome-underline mx-auto mb-4"></div>
								<p class="welcome-lead mb-3">
									My name is
									<span class="fw-bold text-orange">Scott Deutsch</span>. I have
									an app that will improve your quality of life... It's called
									<span class="fw-bold text-orange">Grub Vision</span>.<br />
									Grub Vision is a
									<span class="fw-bold text-success">free and easy to use</span>
									mobile app that lets you track what you are eating. You simply
									take a photo of your meal or drink and Grub Vision will give
									you the value of your meal.
								</p>
								<p class="welcome-highlight mb-2">
									Let Grub Vision help you
									<span class="fw-bold text-success">lose serious weight</span>
									and keep it off by helping you make healthier meal choices and
									<span class="fw-bold text-orange">make your doctor happy</span
									>.<br />
									Also, with Grub Vision, you and your family will soon discover
									your favorite restaurants’ healthiest meals!
								</p>
								<p class="welcome-cta mb-0">
									So-ooo-oo, just give me
									<span class="fw-bold text-orange">3 minutes</span> to help you
									eat smarter; eat healthier; and improve your quality of life
									today and tomorrow!!!
								</p>
							</div>
						</div>
					</div>
					<div class="row justify-content-center mb-4">
						<!-- Use three images from the home page assets -->
						<div class="col-md-4 mb-4 text-center">
							<img
								src="../assets/gyro.png"
								alt="Example 1"
								class="img-fluid mb-2 marketing-img" />
						</div>
						<div class="col-md-4 mb-4 text-center">
							<img
								src="../assets/italian-beef.png"
								alt="Example 2"
								class="img-fluid mb-2 marketing-img" />
						</div>
						<div class="col-md-4 mb-4 text-center">
							<img
								src="../assets/chef-spag.png"
								alt="Example 3"
								class="img-fluid mb-2 marketing-img" />
						</div>
					</div>
					<div class="row justify-content-center">
						<div class="col-lg-10 mx-auto">
							<div
								class="bg-white bg-opacity-90 p-4 p-md-5 rounded-4 shadow text-center">
								<p class="mb-4 lead">
									With Grub Vision, in around 10 seconds you'll know what you
									are eating and how healthy your meal is for YOU!<br />
									All you do is take a picture of your meal…
								</p>
								<h2 class="fw-bold mb-5">Getting Started is Simple</h2>
								<div class="row justify-content-center g-4">
									<!-- Step 1 -->
									<div class="col-md-4">
										<div
											class="getting-started-step p-4 rounded-3 h-100 d-flex flex-column justify-content-center">
											<div class="step-icon mb-3">
												<i
													class="bi bi-cloud-arrow-down-fill"
													style="font-size: 3rem; color: #f97316"></i>
											</div>
											<h5 class="fw-bold mb-2">1. Get the App</h5>
											<p class="mb-0">
												Use the
												<router-link to="/signup">web version</router-link>
												or download from the
												<a
													href="https://play.google.com/store/apps/details?id=com.digitalfuturelabs.grubvision"
													target="_blank"
													>Google Play Store</a
												>.
											</p>
										</div>
									</div>

									<!-- Step 2 -->
									<div class="col-md-4">
										<div
											class="getting-started-step p-4 rounded-3 h-100 d-flex flex-column justify-content-center">
											<div class="step-icon mb-3">
												<i
													class="bi bi-person-plus-fill"
													style="font-size: 3rem; color: #f97316"></i>
											</div>
											<h5 class="fw-bold mb-2">2. Create Your Account</h5>
											<p class="mb-0">
												A quick and easy sign-up process to personalize your
												experience.
											</p>
										</div>
									</div>

									<!-- Step 3 -->
									<div class="col-md-4">
										<div
											class="getting-started-step p-4 rounded-3 h-100 d-flex flex-column justify-content-center">
											<div class="step-icon mb-3">
												<i
													class="bi bi-camera-fill"
													style="font-size: 3rem; color: #f97316"></i>
											</div>
											<h5 class="fw-bold mb-2">3. Snap a Meal</h5>
											<p class="mb-0">
												Just click 'add' and take a picture of your food to get
												instant insights.
											</p>
										</div>
									</div>
								</div>
								<p class="mt-5 mb-0 fw-bold">
									Thank you for choosing Grub Vision!
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Collapsible: Original Sections (Pizza, Food Value, Salad, Allergy, Restaurant, Meal Plan, Plus Teaser) -->
		<section class="collapsed-original-sections py-2">
			<div class="text-center">
				<button
					class="btn btn-lg btn-gradient-toggle mb-3 d-inline-flex align-items-center gap-2"
					@click="showOriginalSections = !showOriginalSections"
					:aria-expanded="showOriginalSections.toString()"
					:aria-controls="'original-sections-content'">
					<span>
						{{
							showOriginalSections
								? "Hide More Features & Examples"
								: "Show More Features & Examples"
						}}
					</span>
					<svg
						:style="{
							transition: 'transform 0.3s',
							transform: showOriginalSections
								? 'rotate(180deg)'
								: 'rotate(0deg)',
						}"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M7 10l5 5 5-5"
							stroke="#fff"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round" />
					</svg>
				</button>
			</div>
			<div v-if="showOriginalSections" id="original-sections-content">
				<!-- Pizza Hook Section -->
				<section class="pizza-hook-section py-5">
					<div class="container">
						<div class="row justify-content-center mb-4">
							<div class="col-12 text-center">
								<h2 class="fw-bold display-5 mb-2 pizza-header">
									MMMMMMMM - Pepperoni Pizza
								</h2>
								<!-- <img
									src="../assets/pizza.png"
									alt="Pepperoni Pizza"
									class="pizza-main-img shadow-lg rounded mb-4" /> -->
							</div>
						</div>
						<div
							class="row align-items-center justify-content-center mb-5 step-row">
							<div class="col-md-6 order-md-2 text-center mb-3 mb-md-0">
								<img
									src="../assets/pizza-snap.jpg"
									alt="Pizza Snap"
									class="pizza-step-img shadow rounded" />
							</div>
							<div class="col-md-6 order-md-1 text-center text-md-start">
								<div
									class="pizza-step-text bg-white bg-opacity-75 p-4 rounded-4 shadow">
									<h4 class="fw-bold mb-2 text-orange">
										But how many calories?
									</h4>
									<p class="lead mb-0">Let's find out in a snap!</p>
								</div>
							</div>
						</div>
						<div class="row align-items-center justify-content-center step-row">
							<div class="col-md-6 text-center mb-3 mb-md-0">
								<img
									src="../assets/pizza-info.jpg"
									alt="Pizza Info"
									class="pizza-step-img shadow rounded" />
							</div>
							<div class="col-md-6 text-center text-md-end">
								<div
									class="pizza-step-text bg-white bg-opacity-75 p-4 rounded-4 shadow">
									<h4 class="fw-bold mb-2 text-success">
										Ah, it's
										<span class="calorie-highlight">600</span> calories for
										these 2 slices!
									</h4>
									<p class="mb-0">Grub Vision makes nutrition easy and fun.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<!-- Food Value Hook Section -->
				<section class="food-value-section py-5">
					<div class="container">
						<div class="row align-items-center justify-content-center">
							<div class="col-md-6 text-center mb-4 mb-md-0">
								<img
									src="../assets/info-fingertips.jpg"
									alt="Take a Picture of Your Food"
									class="food-value-img shadow rounded" />
							</div>
							<div class="col-md-6 text-center text-md-start">
								<div
									class="food-value-text bg-white bg-opacity-75 p-4 rounded-4 shadow">
									<h2 class="fw-bold mb-3 text-orange">
										Snap. Discover. Thrive.
									</h2>
									<h4 class="fw-semibold mb-2">
										Take a picture of what you're eating—
									</h4>
									<p class="lead mb-3">
										Uncover the true value of your meal in seconds.<br />
										Calories, nutrition, and more—right at your fingertips.
									</p>
									<p class="mb-0 text-success fw-bold">
										Empower your choices. Eat smarter every day.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<!-- Salad Comparison Section -->
				<section class="salad-compare-section py-5">
					<div class="container">
						<div class="row justify-content-center mb-4">
							<div class="col-12 text-center">
								<h2 class="fw-bold display-6 mb-3 text-success">
									Compare & Choose: Which Salad Wins?
								</h2>
								<p class="lead fw-bold salad-compare-lead">
									Curious which is healthier? Let's see!
								</p>
							</div>
						</div>
						<div
							class="row justify-content-center align-items-center salad-compare-row mb-4 flex-nowrap flex-md-row flex-column">
							<div
								class="col-md-auto col-10 d-flex flex-column align-items-center mb-4 mb-md-0">
								<img
									src="../assets/salad1.png"
									alt="Salad 1"
									class="salad-img shadow rounded-4 mb-2" />
								<div class="fw-bold">Salad with Balsamic Vinaigrette</div>
							</div>
							<div
								class="col-md-auto col-12 d-flex align-items-center justify-content-center my-3 my-md-0">
								<span
									class="vs-badge bg-warning text-dark fw-bold rounded-pill px-4 py-3"
									>VS</span
								>
							</div>
							<div
								class="col-md-auto col-10 d-flex flex-column align-items-center">
								<img
									src="../assets/salad2.png"
									alt="Salad 2"
									class="salad-img shadow rounded-4 mb-2" />
								<div class="fw-bold">Salad with Ranch Dressing</div>
							</div>
						</div>
						<div class="row justify-content-center">
							<div class="col-12 text-center">
								<div
									class="salad-result-text bg-white bg-opacity-75 p-4 rounded-4 shadow d-inline-block">
									<h4 class="fw-bold text-orange mb-2">WOW!</h4>
									<p class="lead mb-0">
										The salad with
										<span class="text-success fw-bold"
											>Balsamic Vinaigrette</span
										>
										is healthier.<br />Small choices, big impact!
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<!-- Allergy Awareness Section -->
				<section class="allergy-section py-5">
					<div class="container">
						<div
							class="row align-items-center justify-content-center flex-md-row flex-column-reverse">
							<div class="col-md-6 text-center text-md-start mt-4 mt-md-0">
								<div
									class="allergy-text bg-white bg-opacity-75 p-4 rounded-4 shadow">
									<h2 class="fw-bold mb-3 text-danger">
										Got a Gluten Allergy?
									</h2>
									<h4 class="fw-semibold mb-2">
										Or any other food sensitivity?
									</h4>
									<p class="lead mb-3">
										Grub Vision alerts you to potential allergens in your
										food—before you take a bite.<br />
										Stay safe, eat smart, and enjoy with confidence!
									</p>
									<p class="mb-0 text-success fw-bold">
										Your health, our priority.
									</p>
								</div>
							</div>
							<div class="col-md-6 text-center">
								<img
									src="../assets/gluten.png"
									alt="Gluten Allergy Alert"
									class="allergy-img shadow rounded mb-3 mb-md-0" />
							</div>
						</div>
					</div>
				</section>
				<!-- Restaurant Tracking Section -->
				<section class="restaurant-section py-5">
					<div class="container">
						<div
							class="row align-items-center justify-content-center flex-md-row flex-column-reverse">
							<div class="col-md-6 text-center text-md-start mt-4 mt-md-0">
								<div
									class="restaurant-text bg-white bg-opacity-80 p-4 rounded-4 shadow">
									<h2 class="fw-bold mb-3 text-primary">Love Eating Out?</h2>
									<h4 class="fw-semibold mb-2">
										Track Your Restaurant Meals—Effortlessly!
									</h4>
									<p class="lead mb-3">
										Whether you're a foodie, a health nut, or just want to
										remember what you ate, Grub Vision has you covered.<br />
										Even if your burger is wrapped, our AI reads the receipt and
										knows what's on your tray.
										<span class="fw-bold text-orange">The POWER OF AI!</span>
									</p>
									<p class="mb-0 text-success fw-bold">
										Track every meal, healthy or not. Yes, you can eat out and
										still stay on top of your nutrition!
									</p>
								</div>
							</div>
							<div class="col-md-6 text-center">
								<img
									src="../assets/restaurant.png"
									alt="Restaurant Tracking"
									class="restaurant-img shadow rounded-4 mb-3 mb-md-0" />
							</div>
						</div>
					</div>
				</section>
				<!-- Meal Plan Section -->
				<section class="meal-plan-section py-5">
					<div class="container">
						<div
							class="row align-items-center justify-content-center flex-md-row flex-column">
							<div class="col-md-6 text-center mb-4 mb-md-0">
								<img
									src="../assets/meal-plan.jpg"
									alt="Meal Plan"
									class="meal-plan-img shadow rounded-4" />
							</div>
							<div class="col-md-6 text-center text-md-start">
								<div
									class="meal-plan-text bg-white bg-opacity-80 p-4 rounded-4 shadow">
									<h2 class="fw-bold mb-3 text-primary">
										Your Meal Plan, Your Way
									</h2>
									<h4 class="fw-semibold mb-2">
										Personalized for your lifestyle
									</h4>
									<p class="lead mb-3">
										Cooking for
										<span class="fw-bold text-orange">2 people</span>? Want to
										eat out
										<span class="fw-bold text-orange">3 times a week</span>?
										Prefer
										<span class="fw-bold text-success">FDA MyPlate</span> or
										your own custom diet?<br />
										We've got you covered!<br />
										Dislike
										<span class="fw-bold text-danger">seafood, mushrooms</span>?
										Love
										<span class="fw-bold text-success"
											>steaks, pizza, burgers, spaghetti and meatballs</span
										>? We'll build your plan around your tastes.<br />
										We'll help you stay on track.
									</p>
									<p class="mb-0 text-primary fw-bold">
										Meal planning made easy, fun, and truly yours.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<!-- Upgrade to Plus Teaser Section -->
				<section class="upgrade-plus-teaser py-4">
					<div class="container d-flex justify-content-center">
						<div class="card shadow-sm border-warning upgrade-plus-card">
							<div
								class="card-body d-flex flex-column flex-md-row align-items-center gap-3 justify-content-between">
								<div class="d-flex align-items-center gap-2">
									<span class="badge bg-warning text-dark fw-bold fs-6"
										>Plus</span
									>
									<span class="fw-bold fs-5"
										>Unlock even more features with
										<span class="text-success">Plus</span>!</span
									>
								</div>
								<router-link
									to="/pricing"
									class="btn btn-outline-warning ms-md-4 mt-2 mt-md-0">
									See Plus Benefits
								</router-link>
							</div>
						</div>
					</div>
				</section>

				<!-- Final Call-to-Action Section -->
				<section class="final-cta-section py-5">
					<div class="container">
						<div class="row justify-content-center">
							<div class="col-lg-10 mx-auto text-center">
								<div
									class="final-cta-text bg-white bg-opacity-90 p-4 rounded-4 shadow">
									<h2 class="fw-bold mb-3 text-final-cta">
										Like What You See?
									</h2>
									<h4 class="fw-semibold mb-2">
										There's so much more to discover!
									</h4>
									<p class="lead mb-3 fw-semibold">
										Grub Vision is packed with features to make your food
										journey smarter, easier, and more fun.<br />
										Give it a try and explore everything you can do—from
										tracking meals to discovering new favorites and getting
										personalized insights.
									</p>
									<p class="lead mb-3 fw-bold text-final-cta">
										Get started with Grub Vision for
										<span class="fw-bold text-warning">FREE</span> today!
										Experience the future of food discovery and nutrition.<br />Android
										app on Google Play is coming soon.
									</p>
									<p class="mb-3 text-final-cta fw-bold">
										Have an idea or want to see a new feature?
										<span class="text-final-cta-cta">Let us know!</span> Your
										feedback helps us grow.
									</p>
									<router-link
										to="/signup"
										class="btn btn-lg btn-final-cta px-5 py-3 mt-2"
										v-if="!Capacitor.isNativePlatform()"
										>Start Exploring</router-link
									>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</section>
	</div>
</template>

<script setup>
	import { RouterLink } from "vue-router"
	import { Capacitor } from "@capacitor/core"
	import { ref } from "vue"
	const showOriginalSections = ref(false)
</script>

<style scoped lang="less">
	.landing-page {
		// font-family: "Segoe UI", sans-serif;

		.navbar {
			box-shadow: none;
		}

		/* Hero Section Styles */
		.hero-section {
			background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
			color: #fff;
			min-height: 80vh;
			display: flex;
			align-items: center;
			.hero-img {
				max-width: 100%;
				width: 350px;
				margin-top: 2rem;
			}
			.hero-cta {
				color: #f97316;
				background-color: #fff;
				border: none;
				font-weight: 600;
				padding: 0.75rem 2rem;
				border-radius: 1.5rem;
				&:hover {
					background-color: darken(#fff, 5%);
					color: darken(#f97316, 15%);
				}
			}
		}

		/* Features Section */
		.features-section {
			background: #fefefe;
			img {
				height: 64px;
			}
		}

		/* Final Call-to-Action Section */
		.final-cta-section {
			background: linear-gradient(
				135deg,
				#f0abfc 0%,
				#a5b4fc 50%,
				#fbbf24 100%
			); /* vibrant, multi-color */
			.final-cta-text {
				font-size: 1.2rem;
				color: #222;
			}
			.text-final-cta {
				color: #a21caf;
			}
			.text-final-cta-cta {
				color: #2563eb;
			}
			.btn-final-cta {
				background: linear-gradient(90deg, #a21caf 0%, #2563eb 100%);
				color: #fff;
				border-radius: 2rem;
				font-weight: bold;
				font-size: 1.2rem;
				box-shadow: 0 4px 24px #a21caf22;
				transition: background 0.2s, color 0.2s;
			}
			.btn-final-cta:hover {
				background: #2563eb;
				color: #fff;
			}
			@media (max-width: 767px) {
				.final-cta-text {
					font-size: 1rem;
					padding: 1.25rem;
				}
				.btn-final-cta {
					font-size: 1rem;
					padding: 0.9rem 2rem;
				}
			}
		}

		/* Buttons */
		.btn-outline-dark {
			color: #000;
			border-color: #000;
			&:hover {
				background-color: #000;
				color: #fff;
			}
		}

		/* Pizza Hook Section */
		.pizza-hook-section {
			background: linear-gradient(
				135deg,
				#fff7ed 0%,
				#f97316 100%
			); /* orange-peach */
			.pizza-header {
				color: #f97316;
				letter-spacing: 2px;
				text-shadow: 0 2px 12px #f9731622;
			}
			.pizza-main-img {
				max-width: 320px;
				width: 90%;
				border-radius: 1.5rem;
				box-shadow: 0 8px 32px #f9731633;
			}
			.pizza-step-img {
				max-width: 340px;
				width: 100%;
				border-radius: 1.25rem;
				box-shadow: 0 4px 24px #0001;
			}
			.pizza-step-text {
				font-size: 1.2rem;
				color: #222;
				.text-orange {
					color: #f97316;
				}
				.calorie-highlight {
					color: #f97316;
					font-size: 2rem;
					font-weight: bold;
					text-shadow: 0 2px 8px #f9731622;
				}
			}
			.step-row {
				margin-bottom: 2.5rem;
			}
			@media (max-width: 767px) {
				.pizza-main-img,
				.pizza-step-img {
					max-width: 90vw;
				}
				.pizza-step-text {
					font-size: 1rem;
					padding: 1.25rem;
				}
			}
		}

		/* Food Value Hook Section */
		.food-value-section {
			background: linear-gradient(
				135deg,
				#fffbe7 0%,
				#fbbf24 100%
			); /* warm yellow */
			.food-value-img {
				max-width: 320px;
				width: 90%;
				border-radius: 1.5rem;
				box-shadow: 0 8px 32px #0ea5e933;
			}
			.food-value-text {
				font-size: 1.2rem;
				color: #222;
				.text-orange {
					color: #f97316;
				}
			}
			@media (max-width: 767px) {
				.food-value-img {
					max-width: 90vw;
				}
				.food-value-text {
					font-size: 1rem;
					padding: 1.25rem;
				}
			}
		}

		/* Salad Comparison Section */
		.salad-compare-section {
			background: linear-gradient(
				135deg,
				#f0fdf4 0%,
				#34d399 100%
			); /* fresh green */
			.salad-img {
				max-width: 320px;
				width: 100%;
				border-radius: 1.5rem;
				box-shadow: 0 8px 32px #0ea5e933;
				margin-left: auto;
				margin-right: auto;
				display: block;
			}
			.vs-badge {
				font-size: 2rem;
				font-weight: bold;
				box-shadow: 0 2px 12px #facc1533;
				z-index: 2;
			}
			.salad-result-text {
				font-size: 1.2rem;
				color: #222;
				.text-orange {
					color: #f97316;
				}
				.text-success {
					color: #15803d;
				}
			}
			.salad-compare-row {
				gap: 0;
			}
			@media (max-width: 767px) {
				.salad-img {
					max-width: 90vw;
				}
				.vs-badge {
					font-size: 1.5rem;
					padding: 0.5rem 1.5rem;
				}
				.salad-compare-row {
					flex-direction: column !important;
					align-items: center !important;
					gap: 0.5rem;
				}
				.col-md-5,
				.col-md-2 {
					max-width: 100%;
					flex: 0 0 100%;
				}
			}
		}

		/* Allergy Awareness Section */
		.allergy-section {
			background: linear-gradient(
				135deg,
				#fef2f2 0%,
				#f43f5e 100%
			); /* soft red-pink */
			.allergy-img {
				max-width: 320px;
				width: 90%;
				border-radius: 1.5rem;
				box-shadow: 0 8px 32px #ef444433;
				margin-left: auto;
				margin-right: auto;
				display: block;
			}
			.allergy-text {
				font-size: 1.2rem;
				color: #222;
				.text-danger {
					color: #dc2626;
				}
				.text-success {
					color: #15803d;
				}
			}
			@media (max-width: 767px) {
				.allergy-img {
					max-width: 90vw;
				}
				.allergy-text {
					font-size: 1rem;
					padding: 1.25rem;
				}
			}
		}

		/* Restaurant Tracking Section */
		.restaurant-section {
			background: linear-gradient(135deg, #f3f4f6 0%, #fbbf24 100%);
			.restaurant-img {
				max-width: 340px;
				width: 90%;
				border-radius: 1.5rem;
				box-shadow: 0 8px 32px #fbbf2433;
				margin-left: auto;
				margin-right: auto;
				display: block;
			}
			.restaurant-text {
				font-size: 1.2rem;
				color: #222;
				.text-primary {
					color: #2563eb;
				}
				.text-orange {
					color: #f97316;
				}
				.text-success {
					color: #15803d;
				}
			}
			@media (max-width: 767px) {
				.restaurant-img {
					max-width: 90vw;
				}
				.restaurant-text {
					font-size: 1rem;
					padding: 1.25rem;
				}
			}
		}

		/* Meal Plan Section */
		.meal-plan-section {
			background: linear-gradient(
				135deg,
				#f3e8ff 0%,
				#a5b4fc 100%
			); /* soft purple/blue */
			.meal-plan-img {
				max-width: 340px;
				width: 90%;
				border-radius: 1.5rem;
				box-shadow: 0 8px 32px #a5b4fc33;
				margin-left: auto;
				margin-right: auto;
				display: block;
			}
			.meal-plan-text {
				font-size: 1.2rem;
				color: #222;
				.text-primary {
					color: #2563eb;
				}
				.text-success {
					color: #15803d;
				}
				.text-orange {
					color: #f97316;
				}
				.text-danger {
					color: #dc2626;
				}
				.text-warning {
					color: #fbbf24;
				}
			}
			@media (max-width: 767px) {
				.meal-plan-img {
					max-width: 90vw;
				}
				.meal-plan-text {
					font-size: 1rem;
					padding: 1.25rem;
				}
			}
		}

		.salad-compare-lead {
			font-weight: 800;
			font-size: 1.35rem;
		}

		.upgrade-plus-card {
			min-width: 320px;
			max-width: 700px;
			border-width: 2px;
			border-radius: 1rem;
			background: #fffbe7;
		}
	}

	.btn-gradient-toggle {
		background: linear-gradient(90deg, #f97316 0%, #a21caf 100%);
		color: #fff;
		font-weight: bold;
		font-size: 1.15rem;
		border: none;
		border-radius: 2rem;
		padding: 0.85rem 2.2rem;
		box-shadow: 0 4px 24px #f9731622;
		transition: background 0.2s, color 0.2s, box-shadow 0.2s;
		outline: none;
		&:hover,
		&:focus {
			background: linear-gradient(90deg, #a21caf 0%, #f97316 100%);
			color: #fff;
			box-shadow: 0 6px 32px #a21caf33;
		}
	}

	.marketing-img {
		height: 600px;
		width: 100%;
		object-fit: contain;
		// background: #f8fafc;
		max-width: 420px;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
	.marketing-copy-section {
		padding-top: 0;
		padding-bottom: 0;
	}
	.welcome-bg-gradient {
		// background: linear-gradient(135deg, #f8fafc 60%, #fbbf24 100%);
		padding-top: 3rem;
		padding-bottom: 3rem;
	}
	.welcome-card {
		background: #fff;
		box-shadow: 0 8px 40px #f9731622, 0 1.5px 8px #0001;
		border-radius: 2.5rem;
		padding: 3rem 2rem 2.5rem 2rem;
		margin-bottom: 2rem;
		position: relative;
	}
	.welcome-title {
		font-size: 2.7rem;
		font-weight: 900;
		color: #f97316;
		letter-spacing: 1px;
		margin-bottom: 0.5rem;
	}
	.welcome-underline {
		width: 80px;
		height: 5px;
		background: linear-gradient(90deg, #f97316 0%, #fbbf24 100%);
		border-radius: 3px;
		margin-bottom: 1.5rem;
	}
	.welcome-lead {
		font-size: 1.25rem;
		color: #f97316;
		font-weight: 500;
		margin-bottom: 1.2rem;
	}
	.welcome-highlight {
		font-size: 1.1rem;
		color: #d97706;
		font-weight: 500;
		margin-bottom: 1.2rem;
	}
	.welcome-cta {
		font-size: 1.15rem;
		color: #a21caf;
		font-weight: 600;
	}
	.text-orange {
		color: #f97316 !important;
	}
	.text-success {
		color: #15803d !important;
	}

	.getting-started-step {
		background-color: #fff;
		border: 1px solid #dee2e6;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
	}

	.getting-started-step:hover {
		transform: translateY(-10px);
		box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
	}
</style>
